/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import defineConf from "../../config/defineConf";
import MomSysMstMaterialCopyCreateDialog from "../dialogTypes/MomSysMstMaterialCopyCreateDialog";

function MomSysMstMaterialCopyCreateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, onSelectGrid, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    useEffect(() => {
        if (schema) { 
            let columnMap = {};
            schema.columns.map(column => columnMap[column.name] = column);
            schema.columnMap = columnMap;
        }
    }, [schema]);

    const onOpen = () => {
        if(onSelectGrid) {
            setFormData(onSelectGrid);
        }
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    const checkShowCallback = (formData, column) => {
        if (formData.opCode === defineConf.opCode.PUR2) {
            formData.cutCode1 = null;
            formData.cutCode2 = null;

            switch(column.name) {
                case "cutCode1" : 
                case "cutCode2" : 
                    return false;

                default :
                    return true;
            }
        } else {
            switch(column.name) {
                case "cutCode1" : 
                case "cutCode2" : 
                    return true;

                default :
                    return true;
            }
        }
    }

    return (
        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} {...others} />
            <MomSysMstMaterialCopyCreateDialog
                id={id+"append-dialog"}
                title={t(`dialog.title.${schema.name}.create`)}
                schema={schema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                checkShowCallback={checkShowCallback}
            />
        </>
    );
}

export default MomSysMstMaterialCopyCreateButton;

